import React, { useState, useRef, useCallback } from 'react';

interface DebouncedFilterInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
}

export const DebouncedFilterInput: React.FC<DebouncedFilterInputProps> = ({
    value,
    onChange,
    placeholder = '',
    disabled = false,
    className = 'filter-input'
}) => {
    const [tempValue, setTempValue] = useState(value);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const applyFilter = useCallback((newValue: string) => {
        if (newValue !== value) {
            onChange(newValue);
        }
    }, [onChange, value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTempValue(e.target.value);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            applyFilter(e.currentTarget.value);
        }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        applyFilter(e.currentTarget.value);
    };

    React.useEffect(() => {
        setTempValue(value);
    }, [value]);

    return (
        <input
            type="text"
            className={className}
            placeholder={placeholder}
            value={tempValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            disabled={disabled}
        />
    );
};
